import { useEffect, useState } from "react";
import { trans, uuidv4 } from "utils/helpers";

import { Button } from "components/Button/Button";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import { MessageType, TaxTypeItem } from "types/enum";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICON_TYPE } from "utils/constants";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ItemsForPriceList } from "pages/InventoryAndSales/Sales/PriceList/components/ItemsForPriceList/ItemsForPriceList";
import { itemTaxBatchAdd } from "./api";
interface Form {
    onHide: () => void;
    ItemTaxeslistcallback?: (list) => void;
    reload?: () => void;
    isGroup?:any
}
export const ItemTaxesForm = ({ isGroup=false,  ItemTaxeslistcallback, onHide ,reload}: Form) => {



    const [mode, setMode] = useState("create");
    const [resetForm, setResetForm] = useState(false);
    const [editForm, setEditForm] = useState<any>();
    const [ItemTaxesType, setItemTaxesType] = useState(1);
    const [title, setTitle] = useState<any>();
    const [userChanges, setUserChanges] = useState({});
  const [selectedItemList, setSelectedItemList] = useState<any>([]);
  const [showTree, setShowTree] = useState<any>();
  const [treeType, setTreeType] = useState<any>();

    const [loading, setLoading] = useState(false);

  const itemCodeHandeler = (obj,hasPrice) => {
    setLoading(true);
    setSelectedItemList((prev)=>{return{
      ...prev,
      [treeType.type]: obj.Code,
    }});


    setShowTree(false);
  };
    const submit =async (e) => {
        e.preventDefault();
        
        let data ={
            Id:uuidv4(),
            TaxTypeItemEnum:e.target.TaxTypeItem.value ,
            TaxTypeItem:trans(TaxTypeItem[e.target.TaxTypeItem.value]) ,
            TaxRate: +e.target.TaxRate.value, 
        }
        if(isGroup){
          try {
            await itemTaxBatchAdd({
              "From": selectedItemList.From?selectedItemList.From  :null,
              "To": selectedItemList.To?selectedItemList.To  :null,
              "TaxTypeItem":+data.TaxTypeItemEnum,
              "TaxRate": data.TaxRate
            })
              onHide()

          } catch (error) {
            
          }


        }else{

          ItemTaxeslistcallback&& ItemTaxeslistcallback(data)
        }
            
    }

    function cancel() {
        if(sessionStorage.getItem("changingforms")+""=="true"){
            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
            //     sessionStorage.setItem("changingforms" , "false");
            //     setUserChanges({});
            //     setEditForm(null);
            //     onHide()
            // });
            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                sessionStorage.setItem("changingforms" , "false");
                setUserChanges({});
                setEditForm(null);
                onHide()
            });
        }else{
            setEditForm(null);
            onHide()    
        };

    }


    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
      };

  function SelectItemCode(e  ) {
    setTreeType({type:e });
    setShowTree(true);
  }
    useEffect(() => {
        if(Object.values(userChanges).filter((item)=>item!=null).length>0){

            sessionStorage.setItem("changingforms" , "true")
              window.addEventListener('beforeunload', handleBeforeUnload);
              return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
              };
        }else{
            sessionStorage.setItem("changingforms" , "false")
            window.removeEventListener('beforeunload', handleBeforeUnload);

        }
    }, [userChanges]);



    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
        
        }
    }, [resetForm]);


    return (
        <>

              {showTree && (
                <ModalForm
                  mode={mode}
                  title="ItemTree"
                  onHide={() => setShowTree(false)}
                  show={showTree}
                >
                  <ItemsForPriceList
                    isWarehouseItem={!selectedItemList.allWarehouses}
                    defualtHasPriceUnit={false}
                    isGroup={isGroup}
                    onHide={() => {
                      setShowTree(false);
                    }}
                    itemCodeHandeler={(e, mode, hasPriceUnit) => {
                    itemCodeHandeler(e,hasPriceUnit);
                    }}
                  />
                </ModalForm>
              )}
            <div className="cartable-action">
                 <>
                                 <div className="card mb-4">

                                    <form className="TypeSettingForm row card-body " onSubmit={submit}>
                                         <div className="col-lg-4 ">
                                         <EnumerationTypeSelect
                                            required={true}
                                            value={editForm?.TaxTypeItem}
                                            Change={(e) => { setUserChanges({ ...userChanges, ...e }); } }
                                            type="SelectBox"
                                            name="TaxTypeItem"
                                            mode={mode}
                                            label="TaxTypeItem" 
                                            enumTypeSelect="TaxTypeItem"                                       />
                                         </div>
                                        <div className="col-md-2 col-sm-12">
                                            <Textbox min={0} max={100} Change={(e)=>{setUserChanges({...userChanges , ...e})}} onChange={(e)=>{setTitle(e.target.value) }} required={true} textboxName={"TaxRate"} textboxType="number" resetForm={resetForm} labelText={"TaxRate"} mode={mode}  defaultValue={editForm?.ItemTaxesName} />
                                        </div>     
                                        <div className="row col-md-4 col-sm-12">
                                            {isGroup&&
                                                                    <>
                          <div
                            className="col-md-6 "
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            <Textbox
 
                              onChange={(e) => {
                                setSelectedItemList({
                                    ...selectedItemList,
                                    From: e.target.value,
                                });
                              }}
                              placeholder={trans('itemCode')}
                              textboxName={"from"}
                              textboxType="text"
                              labelText={"from"}
                              mode={mode}
                              defaultValue={
                                selectedItemList?.From
                              }
                            />
                            <div style={{ marginTop: "4px", width: "10%" }}>
                              <Button
                                Icon={true}
                                value={
                                  <button
                                    onClick={(e) => SelectItemCode("From"  )}
                                    type="button"
                                    className="checkButton"
                                  >
                                    {" "}
                                    <FontAwesomeIcon
                                      icon={[ICON_TYPE, "diagram-project"]}
                                      size="1x"
                                    />
                                  </button>
                                }
                                btnType="primary"
                                onClick={(e) => SelectItemCode("From"  )}
                              />
                            </div>
                          </div>
                          <div
                            className="col-md-6"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            <Textbox

                              onChange={(e) => {
                                setSelectedItemList({
                                  ...selectedItemList,
                                  To: e.target.value,

                                });
                              }}
                              textboxName={"To"}
                              textboxType="text"
                              placeholder={trans('itemCode')}
                              labelText={"To"}
                              mode={mode}
                              defaultValue={
                                selectedItemList?.To
                              }
                            />
                           
                            <div style={{ marginTop: "4px", width: "10%" }}>
                              <Button
                                Icon={true}
                                value={
                                  <button
                                    onClick={(e) => SelectItemCode("To"  )}
                                    type="button"
                                    className="checkButton"
                                  >
                                    {" "}
                                    <FontAwesomeIcon
                                      icon={[ICON_TYPE, "diagram-project"]}
                                      size="1x"
                                    />
                                  </button>
                                }
                                btnType="primary"
                                onClick={(e) => SelectItemCode("To"  )}
                              />
                            </div>
                          </div>

                        </>
                                            
                                            
                                            
                                            
                                            }

                                        </div>   

                                        {  mode !="view"?
                                              <div className="col-lg-12 mt-1 btns_form">
                                              <Button value="Save" btnType="submit" />
                                              <Button btnType="cancel" value="Cancel" onClick={()=>{cancel()}} />
                                              </div>
                                              :
                                              <div className="col-lg-12 mt-1 btns_form">
                                              <Button btnType="primary" value="close" onClick={()=>{cancel()}} />
                                              </div>

                                          }                        
                                    </form>

                                </div >
                    </>

            </div>
        </>

    );
}